import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("seifried_user") || "null");
    } catch {
      return null;
    }
  });
  const [liefernummer, setLiefernummer] = useState(
    () => localStorage.getItem("seifried_liefernummer") || ""
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("seifried_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        localStorage.setItem("seifried_user", JSON.stringify(res.data));
        if (res.data.rolle === "lieferant" && res.data.liefernummern?.length) {
          const stored = localStorage.getItem("seifried_liefernummer");
          if (!stored || !res.data.liefernummern.includes(stored)) {
            setLiefernummer(res.data.liefernummern[0]);
            localStorage.setItem("seifried_liefernummer", res.data.liefernummern[0]);
          }
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("seifried_token", res.data.token);
    localStorage.setItem("seifried_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    if (res.data.user.rolle === "lieferant" && res.data.user.liefernummern?.length) {
      setLiefernummer(res.data.user.liefernummern[0]);
      localStorage.setItem("seifried_liefernummer", res.data.user.liefernummern[0]);
    }
    return res.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("seifried_token");
    localStorage.removeItem("seifried_user");
    localStorage.removeItem("seifried_liefernummer");
    setUser(null);
    setLiefernummer("");
  }, []);

  const wechsleLiefernummer = useCallback((nr) => {
    setLiefernummer(nr);
    localStorage.setItem("seifried_liefernummer", nr);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, liefernummer, wechsleLiefernummer }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
